import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Layout from './components/Layout';
import './custom.css';

const App = () => {
    return (
        <Layout>
            <Routes>
                {AppRoutes.map((route, index) =>
                    route.index ? (
                        <Route key={index} index element={route.element} />
                    ) : (
                        <Route key={index} path={route.path} element={route.element} />
                    )
                )}
            </Routes>
        </Layout>
    );
};

export default App;
